/* Registrazione service worker + rilevamento aggiornamenti.
   Attivo solo in produzione per non interferire con l'hot-reload del preview. */
let waitingWorker = null;

export function applyPwaUpdate() {
  if (waitingWorker) {
    waitingWorker.postMessage("SKIP_WAITING");
  }
}

export function registerPwa(onUpdateAvailable) {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Se c'è già un worker in attesa all'avvio
        if (reg.waiting && navigator.serviceWorker.controller) {
          waitingWorker = reg.waiting;
          onUpdateAvailable && onUpdateAvailable();
        }
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              waitingWorker = nw;
              onUpdateAvailable && onUpdateAvailable();
            }
          });
        });
        // Controlla aggiornamenti al ritorno in foreground
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") reg.update().catch(() => {});
        });
      })
      .catch(() => {});

    // Quando il nuovo SW prende il controllo, ricarica una sola volta
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
